import React from 'react';
import Route from 'react-router/lib/Route';
import Router from 'react-router/lib/Router';
import Redirect from 'react-router/lib/Redirect';
import IndexRedirect from 'react-router/lib/IndexRedirect';
import IndexRoute from 'react-router/lib/IndexRoute';
import { AdBuilder } from 'containers/AdBuilder/Loadable';
import { AdsDashboard, AdsWrapper, AdsList, Audiences, AudienceBuilder, AudienceBuilderWrap, AudienceList, LeadFormList } from 'containers/Ads/Loadable';
import Agreements from 'containers/Agreements/Agreements';
import { Billing } from 'containers/Billing/Loadable';
import { BillingManagement } from 'containers/BillingManagement/Loadable';
import { ContentLibrary } from 'containers/ContentLibrary/Loadable';
import { ContractPreview } from 'containers/ContractPreview/Loadable';
import { ComposeScreen } from 'containers/ComposeScreen/Loadable';
import { ContractSignableView } from 'containers/ContractSignableView/Loadable';
import { FacebookFacelift, RecentFBPosts, Reports, ReportsDashboard, SummaryReport, SummaryReportList, UpcomingContent } from 'containers/Reports/Loadable';
import { GroupPosts, GroupPostCompose } from 'containers/GroupPost/Loadable';
import { LoggedOutDraftApproval } from 'containers/LoggedOutDraftApproval/Loadable';
import { Login } from 'containers/Login/Loadable';
import { LoginSuccess } from 'containers/LoginSuccess/Loadable';
import { MessageCenter } from 'containers/MessageCenter/Loadable';
import { NewContract } from 'containers/NewContract/Loadable';
import { NotFound } from 'containers/NotFound/Loadable';
import { OrgClientDetail } from 'containers/OrgClientDetail/Loadable';
import { OrgSettings } from 'containers/OrgSettings/Loadable';
import { OrgTimezone } from 'containers/OrgTimezone/Loadable';
import { OrgUsers, OrgUserDetail } from 'containers/OrgUsers/Loadable';
import { PackageManager } from 'containers/PackageManager/Loadable';
import { PartnerTermsAndConditions, TermsAndConditions } from 'containers/TermsAndConditions/Loadable';
import { PasswordReset } from 'containers/PasswordReset/Loadable';
import { PasswordResetRequest } from 'containers/PasswordResetRequest/Loadable';
import { ReportBuilder } from 'containers/ReportBuilder/Loadable';
import { SocialAccounts } from 'containers/SocialAccounts/Loadable';
import { UserSettings } from 'containers/UserSettings/Loadable';
import { WhiteLabel } from 'containers/WhiteLabel/Loadable';
import { InviteUserOnboarding } from 'containers/InviteUserOnboarding/Loadable';
import { BillingCommissions } from 'containers/BillingCommissions/Loadable';
import { PartnerOnboardingSigninRedirect } from 'containers/PartnerOnboardingSigninRedirect/Loadable';
import { SignedContractInternalPayment } from 'containers/SignedContractInternalPayment/Loadable';
import { HostedPrivacyPolicy } from 'containers/HostedPrivacyPolicy/Loadable';
import { App } from 'containers/App/Loadable';
import { ReportPdfRender } from 'containers/ReportPdfRender/Loadable';
import { PartnerSettingsWrap, PartnerSettings } from 'containers/PartnerSettings/Loadable';
import { AdminDashboard, Clients, ClientDetail, ClientDetailWrap, ClientNew, Partners, PartnerClients, PartnerClientDetail, Team, TeamMemberDetail } from 'containers/Admin/Loadable';
import { AdsPlanner } from 'containers/AdsPlanner/Loadable';
import { Schedule, DraftPosts, PublishedPosts, Queues } from 'containers/Publishing/Loadable';
import { NewPartnerAgreement, NewPartnerUserSetup } from 'containers/PartnerAgreements/Loadable';
import { InvoiceWrap, OrgBillingWrap, OrgBillingHistory } from 'containers/OrgBillingHistory/Loadable';
import RouterMiddleware from './helpers/routerMiddleware';
export default (function (store) {
  var middleware = new RouterMiddleware(store);
  return /*#__PURE__*/React.createElement(Route, {
    path: "/",
    component: App,
    onEnter: middleware.onEnterApp,
    onChange: middleware.handleChangeRoute
  }, /*#__PURE__*/React.createElement(IndexRoute, {
    onEnter: middleware.redirectToOrganization
  }), /*#__PURE__*/React.createElement(Route, {
    path: "logout",
    onEnter: middleware.clearStateAndLogout
  }), /*#__PURE__*/React.createElement(Route, {
    path: "draft-approval/:postHash",
    onEnter: middleware.requireDraftApprovalToken,
    component: LoggedOutDraftApproval
  }), /*#__PURE__*/React.createElement(Route, {
    path: "report-pdf-render",
    onEnter: middleware.reportPdfRenderMiddleware,
    component: ReportPdfRender
  }), /*#__PURE__*/React.createElement(Route, {
    path: "user"
  }, /*#__PURE__*/React.createElement(IndexRedirect, {
    to: "/"
  }), /*#__PURE__*/React.createElement(Route, {
    path: "new",
    onEnter: middleware.requireNewUserInvite,
    component: InviteUserOnboarding
  })), /*#__PURE__*/React.createElement(Route, {
    onEnter: middleware.requireLogin
  }, /*#__PURE__*/React.createElement(Route, {
    path: "global"
  }, /*#__PURE__*/React.createElement(IndexRedirect, {
    to: "clients"
  }), /*#__PURE__*/React.createElement(Route, {
    path: "partner-user-setup",
    component: NewPartnerUserSetup
  }), /*#__PURE__*/React.createElement(Route, {
    path: "partner",
    component: PartnerSettingsWrap,
    onEnter: middleware.requireOrgOwner
  }, /*#__PURE__*/React.createElement(IndexRedirect, {
    to: "billing"
  }), /*#__PURE__*/React.createElement(Route, {
    path: "billing",
    components: BillingManagement
  }), /*#__PURE__*/React.createElement(Route, {
    path: "commissions",
    component: PartnerSettings
  })), /*#__PURE__*/React.createElement(Route, {
    path: "agreements"
  }, /*#__PURE__*/React.createElement(IndexRoute, {
    component: function component() {
      return /*#__PURE__*/React.createElement(Agreements, null);
    },
    onEnter: middleware.requireLikeableLocalUser
  }), /*#__PURE__*/React.createElement(Route, {
    path: "edit/:contractUuid",
    component: function component() {
      return /*#__PURE__*/React.createElement(NewContract, {
        isEdit: true
      });
    },
    onEnter: middleware.requireContract
  }), /*#__PURE__*/React.createElement(Route, {
    path: "new",
    component: NewContract
  }), /*#__PURE__*/React.createElement(Route, {
    path: ":contractUuid/teamview",
    component: ContractPreview,
    onEnter: middleware.requireContract
  }), /*#__PURE__*/React.createElement(Route, {
    path: "partner"
  }, /*#__PURE__*/React.createElement(Route, {
    path: "edit/:contractUuid",
    component: function component() {
      return /*#__PURE__*/React.createElement(NewPartnerAgreement, {
        isEdit: true
      });
    },
    onEnter: middleware.requireContract
  }), /*#__PURE__*/React.createElement(Route, {
    path: "new",
    component: NewPartnerAgreement
  })), /*#__PURE__*/React.createElement(Route, {
    path: "multilocation"
  }, /*#__PURE__*/React.createElement(Route, {
    path: "edit/:contractUuid",
    component: function component() {
      return /*#__PURE__*/React.createElement(NewPartnerAgreement, {
        isEdit: true,
        partnerType: "multilocation"
      });
    },
    onEnter: middleware.requireContract
  }), /*#__PURE__*/React.createElement(Route, {
    path: "new",
    component: function component() {
      return /*#__PURE__*/React.createElement(NewPartnerAgreement, {
        partnerType: "multilocation"
      });
    }
  })), /*#__PURE__*/React.createElement(Route, {
    path: "affiliate"
  }, /*#__PURE__*/React.createElement(Route, {
    path: "edit/:contractUuid",
    component: function component() {
      return /*#__PURE__*/React.createElement(NewPartnerAgreement, {
        isEdit: true,
        partnerType: "affiliate"
      });
    },
    onEnter: middleware.requireContract
  }), /*#__PURE__*/React.createElement(Route, {
    path: "new",
    component: function component() {
      return /*#__PURE__*/React.createElement(NewPartnerAgreement, {
        partnerType: "affiliate"
      });
    }
  }))), /*#__PURE__*/React.createElement(Route, {
    path: "partners",
    onEnter: middleware.requireLikeableLocalUserRole
  }, /*#__PURE__*/React.createElement(IndexRoute, {
    component: Partners
  }), /*#__PURE__*/React.createElement(Route, {
    path: ":partnerId",
    component: PartnerClients
  }), /*#__PURE__*/React.createElement(Route, {
    path: ":partnerId/client/:clientId",
    component: PartnerClientDetail
  })), /*#__PURE__*/React.createElement(Route, {
    path: "clients"
  }, /*#__PURE__*/React.createElement(IndexRoute, {
    component: Clients
  }), /*#__PURE__*/React.createElement(Route, {
    path: "new",
    component: ClientNew
  }), /*#__PURE__*/React.createElement(Route, {
    path: ":clientId",
    component: function component(route) {
      return /*#__PURE__*/React.createElement(ClientDetailWrap, {
        clientId: route.params.clientId
      });
    }
  })), /*#__PURE__*/React.createElement(Route, {
    path: "team"
  }, /*#__PURE__*/React.createElement(IndexRoute, {
    component: Team
  }), /*#__PURE__*/React.createElement(Route, {
    path: ":teamMemberId",
    component: TeamMemberDetail
  })), /*#__PURE__*/React.createElement(Route, {
    path: "dashboard",
    component: AdminDashboard
  }), /*#__PURE__*/React.createElement(Route, {
    path: "report-builder"
  }, /*#__PURE__*/React.createElement(IndexRoute, {
    component: ReportBuilder
  }), /*#__PURE__*/React.createElement(Route, {
    path: "org/:organizationId",
    component: ReportBuilder
  }), /*#__PURE__*/React.createElement(Route, {
    path: "org/:organizationId/reportType/:reportType",
    component: ReportBuilder
  }), /*#__PURE__*/React.createElement(Route, {
    path: "org/:orgId/report/:reportId",
    component: ReportBuilder
  })), /*#__PURE__*/React.createElement(Route, {
    path: "package-manager"
  }, /*#__PURE__*/React.createElement(IndexRoute, {
    component: PackageManager,
    onEnter: middleware.requireLikeableLocalUserRole
  }), /*#__PURE__*/React.createElement(Route, {
    path: ":orgId",
    component: PackageManager
  })), /*#__PURE__*/React.createElement(Route, {
    path: "group-posts"
  }, /*#__PURE__*/React.createElement(IndexRoute, {
    component: GroupPosts
  }), /*#__PURE__*/React.createElement(Route, {
    path: "compose",
    component: GroupPostCompose
  })), /*#__PURE__*/React.createElement(Route, {
    path: "whitelabel",
    onEnter: middleware.handleEnterWhitelabelSettings,
    component: WhiteLabel
  })), /*#__PURE__*/React.createElement(Route, {
    path: "loginSuccess",
    component: LoginSuccess
  }), /*#__PURE__*/React.createElement(Route, {
    path: "org/:organizationId",
    onLeave: middleware.saveOrgPath,
    onEnter: middleware.setOrganization
  }, /*#__PURE__*/React.createElement(IndexRedirect, {
    to: "publishing"
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "schedule",
    to: "publishing"
  }), /*#__PURE__*/React.createElement(Route, {
    path: "ads",
    onEnter: middleware.refreshFacebookAdAccount,
    component: AdsWrapper
  }, /*#__PURE__*/React.createElement(IndexRedirect, {
    to: "dashboard"
  }), /*#__PURE__*/React.createElement(Route, {
    path: "all-ads",
    component: AdsList
  }), /*#__PURE__*/React.createElement(Route, {
    path: "leadforms",
    component: LeadFormList
  }), /*#__PURE__*/React.createElement(Route, {
    path: "audiences",
    component: AudienceList
  }), /*#__PURE__*/React.createElement(Route, {
    path: "dashboard",
    component: AdsDashboard
  }), /*#__PURE__*/React.createElement(Route, {
    path: "audience-builder",
    component: AudienceBuilderWrap
  }), /*#__PURE__*/React.createElement(Route, {
    path: "audience-builder/:fbTargetingConfigId",
    component: AudienceBuilderWrap
  }), /*#__PURE__*/React.createElement(Route, {
    path: "planner",
    component: AdsPlanner
  })), /*#__PURE__*/React.createElement(Route, {
    path: "compose",
    onEnter: middleware.handleEnterComposeRoute,
    component: ComposeScreen
  }), /*#__PURE__*/React.createElement(Route, {
    path: "content",
    onLeave: middleware.stashOrgStateGeneric,
    onEnter: middleware.handleEnterContentRoute
  }, /*#__PURE__*/React.createElement(IndexRoute, {
    component: ContentLibrary
  }), /*#__PURE__*/React.createElement(Route, {
    path: "directory",
    component: ContentLibrary
  }), /*#__PURE__*/React.createElement(Route, {
    path: "bucket/:bucketSlug",
    component: ContentLibrary
  }), /*#__PURE__*/React.createElement(Route, {
    path: "bucket/:bucketSlug/category/:categorySlug",
    component: ContentLibrary
  }), /*#__PURE__*/React.createElement(Route, {
    path: "bucket/:bucketSlug/category/:categorySlug/post/:postId",
    component: ContentLibrary
  }), /*#__PURE__*/React.createElement(Route, {
    path: "category/:categorySlug",
    component: ContentLibrary
  }), /*#__PURE__*/React.createElement(Route, {
    path: "category/:categorySlug/post/:postId",
    component: ContentLibrary
  })), /*#__PURE__*/React.createElement(Route, {
    path: "create-ad/:step",
    onLeave: middleware.stashOrgStateGeneric,
    component: AdBuilder,
    onEnter: middleware.adStepOnEnter
  }), /*#__PURE__*/React.createElement(Route, {
    path: "client-detail",
    component: OrgClientDetail
  }), /*#__PURE__*/React.createElement(Route, {
    path: "message-center",
    onLeave: middleware.stashOrgStateMessageCenter,
    component: MessageCenter
  }), /*#__PURE__*/React.createElement(Route, {
    path: "reports",
    onLeave: middleware.stashOrgStateGeneric,
    component: Reports
  }, /*#__PURE__*/React.createElement(IndexRedirect, {
    to: "dashboard"
  }), /*#__PURE__*/React.createElement(Route, {
    path: "dashboard",
    onLeave: middleware.stashOrgStateGeneric,
    component: ReportsDashboard
  }), /*#__PURE__*/React.createElement(Route, {
    path: "recent-posts",
    onLeave: middleware.stashOrgStateGeneric,
    component: RecentFBPosts
  }), /*#__PURE__*/React.createElement(Route, {
    path: "summary",
    component: SummaryReportList
  }), /*#__PURE__*/React.createElement(Route, {
    path: "summary/:reportId",
    component: SummaryReport
  }), /*#__PURE__*/React.createElement(Route, {
    path: "facebook-facelift",
    component: FacebookFacelift
  }), /*#__PURE__*/React.createElement(Route, {
    path: "facebook-facelift/:reportId",
    component: FacebookFacelift
  }), /*#__PURE__*/React.createElement(Route, {
    path: "upcoming-content",
    component: UpcomingContent
  }), /*#__PURE__*/React.createElement(Route, {
    path: "upcoming-content/:reportId",
    component: UpcomingContent
  })), /*#__PURE__*/React.createElement(Route, {
    path: "publishing"
  }, /*#__PURE__*/React.createElement(IndexRedirect, {
    to: "schedule"
  }), /*#__PURE__*/React.createElement(Route, {
    path: "schedule(/:view)(/:year)(/:month)(/:day)(/:postId)",
    onLeave: middleware.leaveSchedulePage,
    component: Schedule
  }), /*#__PURE__*/React.createElement(Route, {
    path: "published-posts",
    onLeave: middleware.leaveSchedulePage,
    component: PublishedPosts
  }), /*#__PURE__*/React.createElement(Route, {
    path: "draft-posts",
    onLeave: middleware.leaveSchedulePage,
    component: DraftPosts
  }), /*#__PURE__*/React.createElement(Route, {
    path: "queues",
    onLeave: middleware.leaveSchedulePage,
    component: Queues
  })), /*#__PURE__*/React.createElement(Route, {
    path: "social-accounts",
    onLeave: middleware.stashOrgStateGeneric,
    component: SocialAccounts
  }), /*#__PURE__*/React.createElement(Route, {
    path: "settings",
    component: OrgSettings
  }, /*#__PURE__*/React.createElement(IndexRedirect, {
    to: "social-accounts"
  }), /*#__PURE__*/React.createElement(Route, {
    path: "billing-history",
    component: OrgBillingWrap
  }, /*#__PURE__*/React.createElement(IndexRoute, {
    component: OrgBillingHistory
  }), /*#__PURE__*/React.createElement(Route, {
    path: "invoice/:stripeId",
    component: InvoiceWrap
  })), /*#__PURE__*/React.createElement(Route, {
    path: "social-accounts",
    onLeave: middleware.stashOrgStateGeneric,
    onEnter: middleware.forceRefreshUser,
    component: SocialAccounts
  }), /*#__PURE__*/React.createElement(Route, {
    path: "timezone",
    component: OrgTimezone,
    onEnter: middleware.loadTimezoneData
  }), /*#__PURE__*/React.createElement(Route, {
    onLeave: middleware.stashOrgStateGeneric,
    path: "users"
  }, /*#__PURE__*/React.createElement(IndexRoute, {
    component: OrgUsers
  }), /*#__PURE__*/React.createElement(Route, {
    path: ":userId",
    component: OrgUserDetail
  })))), /*#__PURE__*/React.createElement(Route, {
    path: "user"
  }, /*#__PURE__*/React.createElement(Route, {
    path: "settings",
    components: UserSettings
  }))), /*#__PURE__*/React.createElement(Route, {
    onEnter: middleware.requireNotLogged
  }, /*#__PURE__*/React.createElement(Route, {
    path: "login",
    component: Login
  })), /*#__PURE__*/React.createElement(Route, {
    path: "agreements/:contractUuid",
    component: ContractSignableView,
    onEnter: middleware.requireNotLoggedForAgreements
  }), /*#__PURE__*/React.createElement(Route, {
    path: "billing/:contractUuid",
    component: Billing,
    onEnter: middleware.contractBillingPageOnEnter
  }), /*#__PURE__*/React.createElement(Route, {
    path: "billing/signed-agreement/:contractUuid",
    component: SignedContractInternalPayment,
    onEnter: middleware.requireContract
  }), /*#__PURE__*/React.createElement(Route, {
    path: "reset"
  }, /*#__PURE__*/React.createElement(IndexRoute, {
    component: PasswordReset,
    onEnter: middleware.loadPasswordReset,
    onChange: middleware.loadPasswordReset
  }), /*#__PURE__*/React.createElement(Route, {
    path: "request",
    component: PasswordResetRequest
  })), /*#__PURE__*/React.createElement(Route, {
    path: "partner-terms",
    component: PartnerTermsAndConditions
  }), /*#__PURE__*/React.createElement(Route, {
    path: "terms",
    component: TermsAndConditions
  }), /*#__PURE__*/React.createElement(Route, {
    path: "signin",
    component: PartnerOnboardingSigninRedirect
  }), /*#__PURE__*/React.createElement(Route, {
    path: "privacy-policy/:organizationId",
    component: HostedPrivacyPolicy
  }), /*#__PURE__*/React.createElement(Route, {
    path: '*',
    component: NotFound,
    status: 404
  }));
});